import { LOGIN_PATH } from "@airange/shared/oidc-routes";
import {
  resolveUmiSsoGuardRedirect,
  type UmiSsoGuardOptions,
} from "@airange/ui/umi-sso-guard";
import { resolveAdminInternalPathname } from "./admin-auth-routes";
import { sanitizeRedirectPath } from "./sso-redirect";

type AdminSsoGuardOptions = Omit<UmiSsoGuardOptions, "loginPath">;

function parseSearchParams(search = "") {
  return new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
}

export function normalizeAdminLoginSearch(search = "", defaultAuthorizedPath = "/dashboard") {
  const query = parseSearchParams(search);
  const rawRedirect = query.get("redirect");
  if (rawRedirect === null) {
    return search || "";
  }

  const redirectPath = sanitizeRedirectPath(rawRedirect, defaultAuthorizedPath);
  if (redirectPath === defaultAuthorizedPath) {
    query.delete("redirect");
  } else {
    query.set("redirect", redirectPath);
  }

  const suffix = query.toString();
  return suffix ? `?${suffix}` : "";
}

export function resolveAdminSsoGuardRedirect(options: AdminSsoGuardOptions) {
  const internalPathname = resolveAdminInternalPathname(options.pathname);
  const defaultAuthorizedPath = options.defaultAuthorizedPath;
  const guardPathname = internalPathname === "/" ? defaultAuthorizedPath : internalPathname;
  const guardSearch = internalPathname === "/"
    ? ""
    : internalPathname === LOGIN_PATH
      ? normalizeAdminLoginSearch(options.search, defaultAuthorizedPath)
      : options.search;
  const guardHash = internalPathname === "/" ? "" : options.hash;

  return resolveUmiSsoGuardRedirect({
    ...options,
    pathname: guardPathname,
    search: guardSearch,
    hash: guardHash,
    loginPath: LOGIN_PATH,
  });
}
